import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Mask } from 'antd-mobile';
import '@styles/components/menuMask.less';
import { selectShowMenuMask, setShowMenuMask } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';
import { useState } from 'react';

const MenuMask = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const showMenuMask = useSelector(selectShowMenuMask);

  /**
   * 关闭菜单遮罩层
   */
  const closeMenuMask = () => {
    dispatch(setShowMenuMask(false));
  };

  const [menuList, setMenuList] = useState([
    { name: '首页', route: '/' },
    { name: '看模王', route: '/digitaltwin' },
    { name: '桥梁设计', route: '/introduce' },
    { name: '跨界云空间', route: '/ksjspace' },
    { name: 'BIM设计', route: '/civilstationdesigner' },
    { name: '智慧工地', route: '/civilstationconstru' },
    { name: '数字孪生', route: '/digitaltwin' },
    { name: '方案可视化评审', route: '/visualreview' },
    {
      name: '院校解决方案',
      route: '',
      children: [
        { name: '1 + X 市政道桥', route: '/municipalRoadBridge' },
        { name: '院校软件支持', route: '/collegeSoftwareSupport' },
      ],
      dropdown: false,
    },
    { name: 'Bentley产品', route: '/bentleproduct' },
    { name: '了解跨世纪', route: '/aboutksj' },
  ]);

  // 展开子级
  const toggle = (item: any) => {
    let newMenu = menuList.find((a) => a.name === item.name);
    newMenu!.dropdown = !newMenu!.dropdown;
    setMenuList([...menuList]);
  };

  let menuListJSX = menuList.map((item) => {
    if (item.children) {
      return (
        <div key={item.name}>
          <div className={'item'} onClick={() => toggle(item)}>
            <div className="flex ac jsb">
              <span>{item.name}</span>
              <div className={item.dropdown ? 'rotate' : ''}>▲</div>
            </div>
          </div>
          <div className={!item.dropdown ? 'dropdown-box dropdown' : 'dropdown-box'}>
            {item.children.map((child) => {
              return (
                <div key={child.name} className={'dropdown-item'} onClick={() => jumpRoute(child)}>
                  <span>{child.name}</span>
                </div>
              );
            })}
          </div>
        </div>
      );
    } else {
      return (
        <div key={item.name} className={'item'} onClick={() => jumpRoute(item)}>
          <span>{item.name}</span>
        </div>
      );
    }
  });

  /**
   * 菜单路由跳转
   * @param item
   */
  const jumpRoute = (item: typeof menuList[0]) => {
    if (item.route !== '') {
      history.push(item.route);
      closeMenuMask();
    }
  };

  return (
    <Mask className={'menu-mask'} visible={showMenuMask} opacity={0.9} getContainer={document.body}>
      <div className={'content'}>
        <div className={'header'}>
          <img className={'bw-logo'} src={require('@images/common/company.jpg').default} alt="" />
          <img
            className={'close'}
            src={require('@images/common/close3.png').default}
            alt=""
            onClick={closeMenuMask}
          />
        </div>
        <div className={'menu-list'}>{menuListJSX}</div>
      </div>
    </Mask>
  );
};

export default MenuMask;
